// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper.swiper-cards {
  overflow: visible;
}
.swiper-cards .swiper-slide {
  transform-origin: center bottom;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./node_modules/swiper/modules/effect-cards.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;UAC3B,2BAA2B;EACnC,gBAAgB;AAClB","sourcesContent":[".swiper.swiper-cards {\n  overflow: visible;\n}\n.swiper-cards .swiper-slide {\n  transform-origin: center bottom;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
